import React from 'react';
import {UploadField} from '@navjobs/upload'
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {uploadVideo} from "../reducers/videos/actions";

function UploadWrapper({uploadVideo, children}) {
    const fileChangedHandler = (files) => {
        uploadVideo(files[0]);
    };
    return (
        <UploadField
            onFiles={fileChangedHandler}
            containerProps={{
                className: 'resume_import'
            }}
            uploadProps={{
                accept: '.mp4',
            }}
        >
            {children}
        </UploadField>
    );
}

UploadWrapper.propTypes = {
    uploadVideo: PropTypes.func,
    children: PropTypes.any,
};

export default connect(null,
    dispatch => {
        return {
            uploadVideo: (video) => dispatch(uploadVideo({video}))
        };
    })(UploadWrapper);
